export default "__VITE_ASSET__B5Ja_xb0__"